// removed by extract-text-webpack-plugin
module.exports = {"mobile":"mobile___rgbTN","header":"header___1LFYb","app-store-link":"app-store-link___1YqdK","ios":"ios___17hm_","android":"android___1uRxv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Mobile/Mobile.scss
// module id = 0y6e
// module chunks = 46